export type ClubListEntry = {
  clubID: number;
  backendID: string;
  name?: string;
  hidden?: boolean;
  [key: string]: unknown;
};

type NormalizedClubList = {
  clubs: ClubListEntry[];
  isValid: boolean;
};

export const isClubListEntry = (value: unknown): value is ClubListEntry => {
  if (typeof value !== "object" || value === null) {
    return false;
  }

  const club = value as Record<string, unknown>;
  return (
    typeof club.clubID === "number" &&
    Number.isFinite(club.clubID) &&
    typeof club.backendID === "string" &&
    club.backendID.length > 0
  );
};

export const normalizeClubList = (value: unknown): NormalizedClubList => {
  if (!Array.isArray(value) || !value.every(isClubListEntry)) {
    return { clubs: [], isValid: false };
  }

  return { clubs: value, isValid: true };
};
